import React, { PureComponent as Component } from 'react';
import KickImage from 'Reuseables/KickImage';
// import { Link }
import { Container, Button } from 'reactstrap';

import MaintenanceImage from '../../images/503.png';
import MaintenanceGif from '../../images/maintenance.gif';

export default class PageMaintenance extends Component {
  render() {
    return (
      <Container className="page-container">
        <div style={{ flex: 1 }}>
          <div className="not-found">
            <div className="img-wrapper">
              <KickImage src={MaintenanceGif} />
            </div>
            <div style={{ display: "flex", flexDirection: "column", textAlign: "center", marginTop: "50px" }}>
              <h2 style={{ fontWeight: "bolder" }}>Under Maintenance</h2>
              <h6>Our system is currently under maintenance.</h6>
              <h6>We're doing our best and we'll back soon.</h6>
            </div>
          </div>
        </div>
      </Container>
    )
  }
}